import { Component, EventEmitter, Output } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { CheckAliasValidator } from '../../validators/check-alias.validator';
import {
  DefaultMailboxDomain,
  ProximusMailboxPattern,
} from '../../config/my-mail.config';

@Component({
  selector: 'mprd-mailbox-id',
  templateUrl: 'mailbox-id.component.html',
})
export class MailboxIdComponent {
  defaultMailboxDomain: string;
  mailboxIdForm: UntypedFormGroup;
  @Output() mailIdFormStatusAndValue: EventEmitter<any> = new EventEmitter();

  constructor(
    private builder: UntypedFormBuilder,
    private checkAliasValidator: CheckAliasValidator,
  ) {
    this.defaultMailboxDomain = DefaultMailboxDomain;
    this.mailboxIdForm = this.builder.group(
      {
        mailId: [
          '',
          [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(50),
            Validators.pattern(ProximusMailboxPattern),
            this.checkAliasValidator.whiteSpaceCheck(),
            this.checkAliasValidator.atSignCheck(),
          ],
        ],
      },
      { asyncValidator: this.checkAliasValidator.checkAlias('mailId') },
    );

    this.mailboxIdForm.statusChanges.subscribe(() => {
      this.mailIdFormStatusAndValue.emit({
        mailIdFormStatus: this.mailboxIdForm.valid,
        mailId: this.mailboxIdForm.get('mailId').value,
      });
    });
  }

  isMailEmpty() {
    return this.mailboxIdForm.value.mailId?.length === 0;
  }
}
